<div class="tags-page-container">
  @if (initialLoadFailed() && loadError(); as error) {
    <tf-settings-load-error
      [title]="error"
      [message]="'SETTINGS.LOAD_ERROR.MESSAGE' | translate"
      [details]="loadErrorDetails()"
      [retrying]="isLoading()"
      (retry)="reloadTags()" />
  } @else if (!hasLoadedOnce()) {
    <tf-settings-loading-placeholder [rows]="4" [columns]="2" />
  } @else if (showEmptyState()) {
    <tf-settings-inline-message
      [message]="actionError()"
      messageId="tags-action-error"
      (dismissed)="clearActionError()" />

    <tf-empty-state
      [title]="'SETTINGS_TAGS.EMPTY.TITLE' | translate"
      [body]="'SETTINGS_TAGS.EMPTY.BODY' | translate">
      <svg
        empty-state-illustration
        class="settings-empty-illustration tags-empty-illustration"
        width="96"
        height="96"
        viewBox="0 0 100 100"
        fill="none"
        aria-hidden="true">
        <path
          class="tags-empty-illustration__tag tags-empty-illustration__tag--back"
          d="M27 22H61L82 43L51 74H17V40Z" />
        <path
          class="tags-empty-illustration__tag tags-empty-illustration__tag--front"
          d="M35 31H68L84 47L55 76H24V45Z" />
        <circle class="tags-empty-illustration__hole" cx="44" cy="45" r="5" />
        <path class="tags-empty-illustration__line" d="M53 48H70M45 59H65" />
      </svg>
      <p-button
        empty-state-actions
        icon="pi pi-plus"
        [label]="'SETTINGS_TAGS.CREATE_TAG' | translate"
        [disabled]="!canCreateTag()"
        [pTooltip]="canCreateTag() ? '' : ('GENERAL.NO_PERMISSION' | translate)"
        tooltipPosition="top"
        (onClick)="createTag()" />
      <p-button
        empty-state-actions
        icon="pi pi-refresh"
        severity="secondary"
        [loading]="isLoading()"
        [disabled]="isLoading()"
        [ariaLabel]="'SETTINGS_TAGS.RELOAD_TAGS' | translate"
        (onClick)="reloadTags()" />
    </tf-empty-state>
  } @else {
    <tf-settings-list-header
      [searchQuery]="searchQuery()"
      [searchPlaceholder]="'SETTINGS_TAGS.SEARCH_PLACEHOLDER' | translate"
      [loading]="isLoading()"
      [refreshTooltip]="'SETTINGS_TAGS.RELOAD_TAGS' | translate"
      (searchChange)="onSearchChange($event)"
      (refresh)="reloadTags()">
      <p-button
        headerActions
        [label]="'SETTINGS_TAGS.CREATE_TAG' | translate"
        icon="pi pi-plus"
        severity="primary"
        [disabled]="!canCreateTag()"
        [pTooltip]="canCreateTag() ? '' : ('GENERAL.NO_PERMISSION' | translate)"
        tooltipPosition="top"
        (onClick)="createTag()" />
    </tf-settings-list-header>

    <tf-settings-inline-message
      [message]="actionError()"
      messageId="tags-action-error"
      (dismissed)="clearActionError()" />

    <tf-data-table
      [columns]="columns"
      [value]="visibleTags()"
      [loading]="false"
      [paginator]="true"
      styleClass="p-datatable-sm"
      emptyMessageKey="SETTINGS_TAGS.NO_TAGS_FOUND">
      <ng-template tfColumnDef="name" let-tag>
        <div class="tag-name-cell">
          <tf-tag-editor [tags]="toEditorItems(tag)" [editable]="false" />
          @if (tag.usageCount > 0) {
            <span
              class="tag-usage"
              [pTooltip]="'SETTINGS_TAGS.USAGE_COUNT_TOOLTIP' | translate"
              tooltipPosition="top">
              {{ tag.usageCount }}
            </span>
          }
        </div>
      </ng-template>
      <ng-template tfColumnDef="_actions" let-tag>
        <div class="actions-cell">
          <p-button
            icon="pi pi-pencil"
            severity="secondary"
            [text]="true"
            [rounded]="true"
            size="small"
            [disabled]="!canUpdateTag()"
            [pTooltip]="
              canUpdateTag() ? ('GENERAL.EDIT' | translate) : ('GENERAL.NO_PERMISSION' | translate)
            "
            tooltipPosition="top"
            [attr.aria-label]="('GENERAL.EDIT' | translate) + ' ' + tag.name"
            (onClick)="editTag(tag)" />
          <p-button
            icon="pi pi-trash"
            severity="danger"
            [text]="true"
            [rounded]="true"
            size="small"
            [disabled]="!canDeleteTag()"
            [pTooltip]="
              canDeleteTag()
                ? ('GENERAL.DELETE' | translate)
                : ('GENERAL.NO_PERMISSION' | translate)
            "
            tooltipPosition="top"
            [attr.aria-label]="('GENERAL.DELETE' | translate) + ' ' + tag.name"
            (onClick)="deleteTag(tag)" />
        </div>
      </ng-template>
    </tf-data-table>
  }

  <tf-tag-form-dialog
    [visible]="isDialogVisible()"
    [tag]="editingTag()"
    [isSaving]="isSaving()"
    (save)="onDialogSave($event)"
    (cancelled)="onDialogCancel()"
    (visibilityChange)="onDialogVisibilityChange($event)" />

  <p-confirmDialog />
</div>
